import { useState } from "react";
import { confirmWithoutSignature } from "../lib/agreements-data";
import { useNotice, Notice } from "./Notice";

/**
 * Shown when a booking is blocked because its quote is not signed. Staff can confirm anyway
 * with a reason; the reason, who and when are recorded and shown on the booking.
 */
export function OverrideConfirm({ bookingId, status, label, onDone, onCancel }: { bookingId: string; status: string; label: string; onDone: () => void; onCancel: () => void }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const { notice, setNotice, fail } = useNotice();
  async function go() {
    setBusy(true);
    try {
      await confirmWithoutSignature(bookingId, reason, status);
      onDone();
    } catch (e) {
      fail(e);
      setBusy(false);
    }
  }
  return (
    <div className="card card--alert" role="alertdialog" aria-labelledby={`ovr-${bookingId}`}>
      <div className="card__head"><h2 className="card__title" id={`ovr-${bookingId}`}>No signed quote</h2></div>
      <div className="card__body stack">
        <Notice notice={notice} onDismiss={() => setNotice(null)} />
        <p>{label} can't be confirmed until the client signs the quote. Send the quote for signing from Quotes, or confirm anyway with a reason. The reason is recorded with your name and shown on the booking.</p>
        <label className="field">
          <span className="field__label">Reason for confirming without a signature</span>
          <input className="input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Emergency call-out, client to sign tomorrow" />
        </label>
        <div className="form-actions">
          <button type="button" className="btn btn--primary btn--sm" disabled={busy || reason.trim().length < 5} aria-busy={busy} onClick={() => void go()}>{busy ? "Confirming" : "Confirm anyway"}</button>
          <button type="button" className="btn btn--outline btn--sm" disabled={busy} onClick={onCancel}>Keep it unconfirmed</button>
        </div>
      </div>
    </div>
  );
}
